const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship Somos Padres',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Tres menciones en vivo: al entrar, en el desarrollo (aquí se explica tu marca) y salida',
      'Video comercial de 20 segundos durante el programa',
      'Transmisión en vivo: Martes 1:00 PM por TNO Network',
      'Presencia en Web, App, SomosPadres.info y Redes Sociales',
      'Asociación con crianza, salud familiar y educación',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de salud, educación, retail infantil, seguros y servicios para el hogar.',
    duration: 'Mensual',
    buttonText: 'Patrocinar Somos Padres',
    highlightedTitle: 'Familia Multiplataforma',
    highlightedContent: [
      'Tu marca viaja con la credibilidad de Yelitza Yánez.',
      'Tres menciones + un comercial de 20 segundos dentro del programa.',
      'Temas de crianza, salud y vida familiar en un solo espacio.',
    ],
    highlightedButtonText: 'Ver Demo del Programa',
  },
  {
    title: 'Segmento Exclusivo por Tema',
    annualPrice: 'Trimestral: 180',
    monthlyPrice: 60,
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Salud, Educación, Pantallas o Crianza',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas especializadas en nicho familiar que buscan relevancia temática.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi Tema',
    highlightedTitle: 'Autoridad en el hogar',
    highlightedContent: [
      'Tu marca se convierte en referente del segmento elegido.',
      'Asociación orgánica con padres y madres que toman decisiones.',
      'Ideal para productos de salud, educación y consumo familiar.',
    ],
    highlightedButtonText: 'Ver Temas Disponibles',
  },
  {
    title: 'Entrevista Patrocinada',
    annualPrice: 'Por sesión: 40',
    monthlyPrice: 40,
    features: [
      'Entrevista de 20 minutos en vivo',
      'Proyección de tus videos promocionales',
      'Mención de puntos de venta o consultorios',
      'Propuesta con respaldo visual en pantalla',
      'Post en redes sociales del programa y SomosPadres.info',
      logoPaginaDofollow,
    ],
    idealFor: 'Pediatras, educadores, emprendedores familiares y expertos en crianza.',
    duration: '20 minutos por sesión',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Proyección y respaldo visual',
    highlightedContent: [
      'Proyección de videos promocionales durante la entrevista.',
      'Mención de puntos de contacto con respaldo en pantalla.',
    ],
    highlightedButtonText: 'Consultar Fechas',
  },
  {
    title: 'Post Patrocinado en TNO Digest',
    annualPrice: 'Por publicación: 50',
    monthlyPrice: 50,
    features: [
      'Publicación patrocinada en las redes sociales de TNO Digest',
      'Alcance en el ecosistema digital de Somos Padres y TNO Digest',
      'Contenido adaptado a familia, salud y educación',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar Post Patrocinado',
    highlightedTitle: 'Visibilidad en TNO Digest',
    highlightedContent: [
      'Tu marca en el feed oficial de TNO Digest.',
      'Ideal para anuncios, lanzamientos o reforzar una campaña.',
    ],
    highlightedButtonText: 'Solicitar Post',
  },
  {
    title: 'Cápsula Familiar / Marca',
    annualPrice: 'Pack 5 Cápsulas: 150',
    monthlyPrice: 40,
    features: [
      'Cápsula de 60-90 segundos con estética del programa',
      'Distribución en redes sociales de TNO y del programa',
      'Tema: tips de crianza, lanzamiento o promoción',
      'Locución profesional en línea con el tono del show',
      logoPaginaDofollow,
    ],
    idealFor: 'Promociones de productos infantiles, salud o servicios para padres.',
    duration: 'Por cápsula',
    buttonText: 'Solicitar Cápsula',
    highlightedTitle: 'Atención en Redes',
    highlightedContent: [
      'Tu mensaje en el ecosistema de Somos Padres.',
      'Formato breve y memorable para máxima recordación.',
    ],
    highlightedButtonText: 'Enviar mi Propuesta',
  },
  {
    title: 'UGC Familiar',
    annualPrice: '80 por pieza',
    monthlyPrice: 80,
    features: [
      'Video dinámico estilo testimonio o rutina familiar real',
      'Demostración del producto en contexto de hogar y crianza',
      'Narrativa humana, sin filtros, enfocada en la solución',
      'Publicación del video en TNO y en Somos Padres',
      'Entrega de archivo original para pauta publicitaria de la marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Productos de consumo masivo, salud infantil, educación y apps para padres.',
    duration: 'Por pieza',
    buttonText: 'Activar Campaña UGC',
    highlightedTitle: 'Prueba social en familia',
    highlightedContent: [
      'El contenido UGC genera mayor confianza que la publicidad tradicional.',
      'Tu marca como recomendación de una voz cercana a padres y madres.',
    ],
    highlightedButtonText: 'Activar Campaña UGC',
  },
];

export default optionsData;
